// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CloudflareTurnstileController from "./cloudflare_turnstile_controller"
application.register("cloudflare-turnstile", CloudflareTurnstileController)

import CookieController from "./cookie_controller"
application.register("cookie", CookieController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LastViewedAnchorController from "./last_viewed_anchor_controller"
application.register("last-viewed-anchor", LastViewedAnchorController)

import LinkShareController from "./link_share_controller"
application.register("link-share", LinkShareController)

import NewPostController from "./new_post_controller"
application.register("new-post", NewPostController)

import NewPostImageToggleController from "./new_post_image_toggle_controller"
application.register("new-post-image-toggle", NewPostImageToggleController)

import NewPostsController from "./new_posts_controller"
application.register("new-posts", NewPostsController)

import OnboardingShareController from "./onboarding_share_controller"
application.register("onboarding-share", OnboardingShareController)

import OnboardingUsernamesController from "./onboarding_usernames_controller"
application.register("onboarding-usernames", OnboardingUsernamesController)

import PostEditController from "./post_edit_controller"
application.register("post-edit", PostEditController)

import PostImgSliderController from "./post_img_slider_controller"
application.register("post-img-slider", PostImgSliderController)

import PostViewController from "./post_view_controller"
application.register("post-view", PostViewController)

import SalePostsController from "./sale_posts_controller"
application.register("sale-posts", SalePostsController)

import ServiceWorkerController from "./service_worker_controller"
application.register("service-worker", ServiceWorkerController)

import TagSearchController from "./tag_search_controller"
application.register("tag-search", TagSearchController)

import UserEditController from "./user_edit_controller"
application.register("user-edit", UserEditController)

import UserProfileBiographyController from "./user_profile_biography_controller"
application.register("user-profile-biography", UserProfileBiographyController)

import UserProfileEditorController from "./user_profile_editor_controller"
application.register("user-profile-editor", UserProfileEditorController)

import VideoPlayController from "./video_play_controller"
application.register("video-play", VideoPlayController)
